import EFCarFridge from 'elem/ui-assets/icons/appliances/EFCarFridge';
import EFComputer from 'elem/ui-assets/icons/appliances/EFComputer';
import EFElectricKettle from 'elem/ui-assets/icons/appliances/EFElectricKettle';
import EFGamingConsole from 'elem/ui-assets/icons/appliances/EFGamingConsole';
import EFNAS from 'elem/ui-assets/icons/appliances/EFNAS';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EfImg from 'elem/ui/ef-img';
import EfInfoSection from 'elem/ui/ef-info-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useState } from 'react';
import EFWiFi from '@elem/ui-assets/icons/appliances/EFWiFi';
import EFTV from '@elem/ui-assets/icons/appliances/EFTV';
import styles from './index.module.scss';
import { imgLocaleA, imgLocaleB, imgLocaleC } from './Imgs';
import { useLang } from '@/i18n';
import { EFPS5H5 } from '@/components/UI/svg/ProductStatic';

export default function TheComp() {
    const { t } = useLang('theProduct.TabB');
    const { locale = 'us' } = useRouter();
    const [active, setActive] = useState(0);

    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const imgC = imgLocaleC[locale] || imgLocaleC['eu'];
    const items = [
        ...(locale === 'kr'
            ? [
                  {
                      title: t('d_title'),
                      desc: t('d_desc'),
                      tab: t('d_tab'),
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1737540786514/d1.png',
                      lists: [
                          {
                              icon: <EFWiFi />,
                              text: t('d_item1'),
                              hour: t('d_item1_hour'),
                          },
                          {
                              icon: <EFNAS />,
                              text: t('d_item2'),
                              hour: t('d_item2_hour'),
                          },
                          {
                              icon: <EFTV />,
                              text: t('d_item3'),
                              hour: t('d_item3_hour'),
                          },
                          {
                              icon: <EFRefrigerator />,
                              text: t('d_item4'),
                              hour: t('d_item4_hour'),
                          },
                          {
                              icon: <EFPS5H5 />,
                              text: t('d_item5'),
                              hour: t('d_item5_hour'),
                          },
                          {
                              icon: <EFCarFridge />,
                              text: t('d_item6'),
                              hour: t('d_item6_hour'),
                          },
                      ],
                  },
              ]
            : []),
        {
            title: t('a_title'),
            desc: t('a_desc'),
            tab: t('a_tab'),
            pc: imgA.pc,
            lists: [
                {
                    icon: <EFNAS />,
                    text: t('a_item1'),
                    hour: t('a_item1_hour'),
                },
                {
                    icon: <EFCarFridge />,
                    text: t('a_item2'),
                    hour: t('a_item2_hour'),
                },
                {
                    icon: <EFGamingConsole />,
                    text: t('a_item3'),
                    hour: t('a_item3_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('a_item4'),
                    hour: t('a_item4_hour'),
                },
                {
                    icon: <EFComputer />,
                    text: t('a_item5'),
                    hour: t('a_item5_hour'),
                },
                {
                    icon: <EFElectricKettle />,
                    text: t('a_item6'),
                    hour: t('a_item6_hour'),
                },
            ],
        },
        {
            title: t('b_title'),
            desc: t('b_desc'),
            tab: t('b_tab'),
            pc: imgB.pc,
            lists: [
                {
                    icon: <EFNAS />,
                    text: t('b_item1'),
                    hour: t('b_item1_hour'),
                },
                {
                    icon: <EFCarFridge />,
                    text: t('b_item2'),
                    hour: t('b_item2_hour'),
                },
                {
                    icon: <EFGamingConsole />,
                    text: t('b_item3'),
                    hour: t('b_item3_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('b_item4'),
                    hour: t('b_item4_hour'),
                },
                {
                    icon: <EFComputer />,
                    text: t('b_item5'),
                    hour: t('b_item5_hour'),
                },
                {
                    icon: <EFElectricKettle />,
                    text: t('b_item6'),
                    hour: t('b_item6_hour'),
                },
            ],
        },
        ...(locale === 'kr'
            ? []
            : [
                  {
                      title: t('c_title'),
                      desc: t('c_desc'),
                      tab: t('c_tab'),
                      pc: imgC.pc,
                      lists: [
                          {
                              icon: <EFNAS />,
                              text: t('c_item1'),
                              hour: t('c_item1_hour'),
                          },
                          {
                              icon: <EFCarFridge />,
                              text: t('c_item2'),
                              hour: t('c_item2_hour'),
                          },
                          {
                              icon: <EFGamingConsole />,
                              text: t('c_item3'),
                              hour: t('c_item3_hour'),
                          },
                          {
                              icon: <EFRefrigerator />,
                              text: t('c_item4'),
                              hour: t('c_item4_hour'),
                          },
                          {
                              icon: <EFComputer />,
                              text: t('c_item5'),
                              hour: t('c_item5_hour'),
                          },
                          {
                              icon: <EFElectricKettle />,
                              text: t('c_item6'),
                              hour: t('c_item6_hour'),
                          },
                      ],
                  },
              ]),
    ];

    const phItems = [
        {
            title: t('a_title'),
            desc: t('a_desc'),
            tab: t('a_tab'),
            pc: imgA.pc,
            lists: [
                {
                    icon: <EFWiFi />,
                    text: t('a_item1'),
                    hour: t('a_item1_hour'),
                },
                {
                    icon: <EFPhone />,
                    text: t('a_item2'),
                    hour: t('a_item2_hour'),
                },
                {
                    icon: <EFFan />,
                    text: t('a_item3'),
                    hour: t('a_item3_hour'),
                },
                {
                    icon: <EFLaptop />,
                    text: t('a_item4'),
                    hour: t('a_item4_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('a_item5'),
                    hour: t('a_item5_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('a_item6'),
                    hour: t('a_item6_hour'),
                },
            ],
        },
        {
            title: t('b_title'),
            desc: t('b_desc'),
            tab: t('b_tab'),
            pc: imgB.pc,
            lists: [
                {
                    icon: <EFWiFi />,
                    text: t('b_item1'),
                    hour: t('b_item1_hour'),
                },
                {
                    icon: <EFPhone />,
                    text: t('b_item2'),
                    hour: t('b_item2_hour'),
                },
                {
                    icon: <EFFan />,
                    text: t('b_item3'),
                    hour: t('b_item3_hour'),
                },
                {
                    icon: <EFLaptop />,
                    text: t('b_item4'),
                    hour: t('b_item4_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('b_item5'),
                    hour: t('b_item5_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('b_item6'),
                    hour: t('b_item6_hour'),
                },
            ],
        },
        {
            title: t('c_title'),
            desc: t('c_desc'),
            tab: t('c_tab'),
            pc: imgC.pc,
            lists: [
                {
                    icon: <EFWiFi />,
                    text: t('c_item1'),
                    hour: t('c_item1_hour'),
                },
                {
                    icon: <EFPhone />,
                    text: t('c_item2'),
                    hour: t('c_item2_hour'),
                },
                {
                    icon: <EFFan />,
                    text: t('c_item3'),
                    hour: t('c_item3_hour'),
                },
                {
                    icon: <EFLaptop />,
                    text: t('c_item4'),
                    hour: t('c_item4_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('c_item5'),
                    hour: t('c_item5_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('c_item6'),
                    hour: t('c_item6_hour'),
                },
            ],
        },
    ];

    const handleChangeTab = (k: number) => {
        setActive(k);
    };

    let curItem = items;
    if (locale === 'ph') {
        curItem = phItems;
    }

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfInfoSection label={t('title')} title={t('label')} desc={t('desc')} />
            <ul className="items">
                {curItem?.map((item: any, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                            <ul className="item-lists">
                                {item?.lists?.map((list: any, m: number) => (
                                    <li className="item-list" key={`${k}_${m}`}>
                                        <div className="list-icon">{list.icon}</div>
                                        <p className="list-text">{list.text}</p>
                                        <p className="list-text list-hour">{list.hour}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="item-img">
                            <EfImg pc={item.pc} />
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items?.map((item: any, k: number) => (
                    <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        {item.tab}
                    </li>
                ))}
            </ul>
        </div>
    );
}
